import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalSettingsService } from '../../../../_Common/_Services/global-settings.service';
import { UserService } from '../../../../_Common/_Services/user.service'; 
import { catchError } from 'rxjs/operators';

@Injectable()
export class MPaymentService {
  constructor(
    private http: HttpClient,
    private globalSettings: GlobalSettingsService,
    private userService: UserService
  ) {}
  createAmountPaid(postObj: any): Observable<any> {
    const url = this.globalSettings.getApiUrl() + '/api/viewData/duesUpdate';
    return this.http.post(url, postObj).pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
}
